export enum IdpRole {
  MYZ_UTENTE = 'MYZ_UTENTE',
  MYZ_STUDENTE = 'MYZ_STUDENTE',
  MYZ_DOCENTE = 'MYZ_DOCENTE',
  MYZ_DOCENTE_UNIVERSITARIO = 'MYZ_DOCENTE_UNIVERSITARIO',
  MYZ_STUDENTE_UNIVERSITARIO = 'MYZ_STUDENTE_UNIVERSITARIO',
  MYZ_PROFESSIONISTA = 'MYZ_PROFESSIONISTA',
}
export const LRS_BASE_URL = process.env.LRS_BASE_URL;
export const LRS_USERNAME = process.env.LRS_USERNAME;
export const LRS_PASSWORD = process.env.LRS_PASSWORD;
export const CONFIG_URL = process.env.CONFIG_URL;
